export const namespaced = true;

export const state = {
    checkedRows: [],
    companyContacts:[],
    profileFields:[],
    carVendorsFields:[],
    airVendorsFields:[],
    hotelVendorsFields:[],

}

export const mutations = {

    ADD_COMPANY_CONTACTS(state, payload){
        state.companyContacts = payload;
    },
    ADD_PROFILE_FIELDS(state, payload){
        state.profileFields = payload;
    },
    ADD_CAR_VENDOR_FIELDS(state, payload){
        state.carVendorsFields = payload;
    },
    ADD_AIR_VENDOR_FIELDS(state, payload){
        state.airVendorsFields = payload;
    },  ADD_HOTEL_VENDOR_FIELDS(state, payload){
        state.hotelVendorsFields = payload;
    }
   
}

export const actions = {

    addCompanyContacts(context, payload){
        context.commit('ADD_COMPANY_CONTACTS', payload);
    },

    addProfileFields(context, payload){
        context.commit('ADD_PROFILE_FIELDS', payload);
    },
    addTravelerProgramFields(context, payload){
        context.commit('ADD_TRAVELER_PROGRAM_FIELDS', payload);
    }

   
}

export const getters = {

    getCompanyContacts(state){
        return state.companyContacts.filter(function(el){
            return el.email !=null && el.name!=null
   
        });

      
           
    }


}